import { Box, Container } from '@material-ui/core';
import AccountListResults from 'src/components/account/AccountListResults';

const AnalyticsAccountList = ({ accounts }) => {

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
        }}
      >
        <Container maxWidth={false}>
          <Box sx={{ pt: 0 }}>
            <AccountListResults accounts={accounts} />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default AnalyticsAccountList;
